import moment from 'moment';

const getPercentage = value => {
  return roundDecimalValues(value * 100, true);
};

const roundDecimalValues = (value = 0, showPercentage = false) => {
  const num = parseFloat(value);
  if (isNaN(num)) {
    return '';
  }

  if (Number.isInteger(num)) {
    return `${num}${showPercentage ? '%' : ''}`;
  }

  return `${Number(num.toFixed(2))}${showPercentage ? '%' : ''}`;
};

const transformAll = ({ data }) => {
  const total = data.infos?.total;
  data = data.infos?.responses?.map(
    ({ birthdate, completionDate, road, skills, score, ...rest }) => ({
      ...rest,
      birthdate: moment(birthdate).parseZone().format('MM/DD/YYYY'),
      completionDate: moment(completionDate).parseZone().format('MM/DD/YYYY'),
      road,
      skills,
      score
    })
  );

  return { data, total };
};

const transformAllReports = ({ data }) => {
  const total = data.studentReport?.total;
  data = data.studentReport?.reportData?.map(
    ({
      roadCompletion,
      roadPerformance,
      totalPreTripHours,
      totalRoadObservationHours,
      preTripCompletion,
      preTripPerformance,
      totalRoadHours,
      skillsCompletion,
      skillsPerformance,
      totalSkillObservationHours,
      totalSkillHours,
      totalClassHours,
      totalTrainingHours,
      locationType,
      lastPretripEvaluationDate,
      lastRoadEvaluationDate,
      lastSkillsEvaluationDate,
      ...rest
    }) => ({
      ...rest,
      preTripCompletion: getPercentage(preTripCompletion),
      preTripPerformance: roundDecimalValues(preTripPerformance, true),
      totalPreTripHours: roundDecimalValues(totalPreTripHours),
      roadCompletion: getPercentage(roadCompletion),
      roadPerformance: roundDecimalValues(roadPerformance, true),
      totalRoadObservationHours: roundDecimalValues(totalRoadObservationHours),
      totalRoadHours: roundDecimalValues(totalRoadHours),
      skillsCompletion: getPercentage(skillsCompletion),
      skillsPerformance: roundDecimalValues(skillsPerformance, true),
      totalSkillObservationHours: roundDecimalValues(totalSkillObservationHours),
      totalSkillHours: roundDecimalValues(totalSkillHours),
      totalClassHours: roundDecimalValues(totalClassHours),
      totalTrainingHours: roundDecimalValues(totalTrainingHours),
      locationType: locationType === 1 ? 'Yard' : 'Classroom',
      lastPretripEvaluationDate: lastPretripEvaluationDate
        ? moment(lastPretripEvaluationDate).parseZone().format('MM/DD/YYYY HH:mm')
        : '',
      lastRoadEvaluationDate: lastRoadEvaluationDate
        ? moment(lastRoadEvaluationDate).parseZone().format('MM/DD/YYYY HH:mm')
        : '',
      lastSkillsEvaluationDate: lastSkillsEvaluationDate
        ? moment(lastSkillsEvaluationDate).parseZone().format('MM/DD/YYYY HH:mm')
        : ''
    })
  );

  return { data, total };
};

const transformBeforeStudentUpdate = item => {
  const {
    id,
    completionDate,
    road,
    skills,
    score,
    studentNumber,
    birthdate,
    status,
    endorsementCode,
    firstName,
    lastName,
    branchId,
    contactNumber,
    hazmatStartDate,
    branch,
    licenseState
  } = item;

  let data = {
    branchId: endorsementCode === 'H' ? branch : branchId,
    contactNumber: contactNumber,
    firstName,
    lastName,
    id,
    completionDate: moment(completionDate).parseZone().format('YYYY-MM-DD'),
    birthdate: moment(birthdate).parseZone().format('YYYY-MM-DD'),
    studentNumber,
    status,
    ...(road && { road: +road }),
    ...(skills && { skills: +skills }),
    ...(score && endorsementCode !== 'H' && { score: +score }),
    ...(score && endorsementCode === 'H' && { hazmatScore: +score }),
    endorsementCode,
    licenseState
  };

  return data;
};

const transformStaffSubmissions = ({ data }) => {
  const total = data.info?.total;
  data = data.info?.studentInfos?.map(
    ({
      studentFirstName,
      studentLastName,
      submittedByFirstName,
      submittedByLastName,
      locationType,
      createdAt,
      ...rest
    }) => ({
      ...rest,
      studentFirstName,
      studentLastName,
      locationType: locationType === 1 ? 'Yard' : 'Classroom',
      createdAt: moment(createdAt).parseZone().format('MM/DD/YYYY HH:mm'),
      submittedBy: `${submittedByFirstName} ${submittedByLastName}`
    })
  );

  return { data, total };
};

export {
  transformAll,
  transformBeforeStudentUpdate,
  transformAllReports,
  transformStaffSubmissions
};
